import { render, staticRenderFns } from "./UserBalanceLimits.vue?vue&type=template&id=20929fbc&"
import script from "./UserBalanceLimits.vue?vue&type=script&lang=js&"
export * from "./UserBalanceLimits.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports